module.exports = __webpack_public_path__ + "img/route_receiver_letter_1.2c2096f4.png";